import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
 <wa-button
    size="small"
    appearance="plain"
    variant="neutral"
    aria-haspopup="menu"
    aria-expanded="false"
    aria-controls="primary-dropdown-menu"
    aria-label="Primary navigation menu"
    class="menu-btn"
    with-caret><slot name="buttonText"></slot></wa-button
  >
  <transition name="dropdown-fade">
    <div id="primary-dropdown-menu" class="dropdown-menu mt-1 closed" role="menu">
      <div class="inside-dropdown-menu">
        <slot></slot>
      </div>
    </div>
  </transition>
`

class NavHeaderPrimaryMenu extends HTMLElement {
  private handleOutsideClick: (event: MouseEvent) => void

  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    // Bind the handler so it can be removed later
    this.handleOutsideClick = this._handleOutsideClick.bind(this)
  }

  connectedCallback() {
    console.log('NavHeaderPrimaryMenu connectedCallback', this)

    const shadow = this.shadowRoot
    if (shadow) {
      const btn = shadow.querySelector('wa-button')
      if (btn) {
        btn.addEventListener('click', () => {
          this.toggleMenu()
        })
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('mousedown', this.handleOutsideClick)
  }

  private _handleOutsideClick(event: MouseEvent) {
    // Check if the click is outside the component
    if (!this.contains(event.target as Node)) {
      this.closeMenu()
    }
  }

  private toggleMenu() {
    const panel = this.shadowRoot?.querySelector('div')
    const btn = this.shadowRoot?.querySelector('wa-button')
    
    if (panel && btn) {
      const isCurrentlyClosed = panel.classList.contains('closed')
      panel.classList.toggle('closed')
      
      // Update aria-expanded state
      btn.setAttribute('aria-expanded', isCurrentlyClosed.toString())

      if (!panel.classList.contains('closed')) {
        document.addEventListener('mousedown', this.handleOutsideClick)
      } else {
        document.removeEventListener('mousedown', this.handleOutsideClick)
      }
    }
  }

  private closeMenu() {
    const panel = this.shadowRoot?.querySelector('div')
    const btn = this.shadowRoot?.querySelector('wa-button')
    
    if (panel && btn && !panel.classList.contains('closed')) {
      panel.classList.add('closed')
      btn.setAttribute('aria-expanded', 'false')
      document.removeEventListener('mousedown', this.handleOutsideClick)
    }
  }
}

if (!customElements.get('ts-navheader-primary-menu')) {
  customElements.define('ts-navheader-primary-menu', NavHeaderPrimaryMenu)
}
export { NavHeaderPrimaryMenu }
